import { NgModule } from '@angular/core';
import { UserDetailsInput, UserDetailsPopupComponent, UserDetailsResult } from './user-details-popup.component';
import { ModalDialogService } from '../../modal-dialog/modal-dialog.service';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [UserDetailsPopupComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule
  ],
  exports: [UserDetailsPopupComponent],
  providers: [ModalDialogService<UserDetailsResult, UserDetailsInput>]
})

export class UserDetailsPopupModule { }
